export enum ThemeMainColor {
    default = '#99338A',
    light = '#FFFFFF',
    dark = '#000000',
}
